module.exports = __webpack_public_path__ + "img/867.c03adc1b.gif";